import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { InsightModule } from '../insight.component.module/insight.module';
import { ServiceModule } from '../services.module/services.module';
import { RegisterWithPINComponent } from './register-with-pin.component';

import { ElementsModule } from '../elements.component.module/elements.module';
import { SharedModule } from '../shared.module/shared.module';

@NgModule({
    declarations: [
        RegisterWithPINComponent
    ],
    imports: [
        ServiceModule,
        FormsModule,
        InsightModule,
        ElementsModule,
        SharedModule
    ],
    exports: [
        RegisterWithPINComponent
    ],
    bootstrap: [],
})
export class OutsightModule {
}
